<template>
    <div>
        <div class="im--pane__table">
            <ColumnsHeader
                :columns="columns"
                @clicked="onClickChild"
            />
            <Row
                v-for="(row, index) in this.rows"
                :row="row"
                :key="$uuid.v4(index)"
                :color="row.color"
                @clicked="onClickChild"
            />
        </div>
        <Content v-if="content.content" :content="content"/>
    </div>
</template>

<script>
import ColumnsHeader from './components/columnsheader.vue';
import Row from './components/row.vue';
import Content from './components/content.vue';

export default {
    props: ['rows','columns'],
    components: {
        ColumnsHeader,
        Row,
        Content
    },
    data() {
        return {
            content: {
                content: null,
                color: null
            }
        };
    },
    methods: {
        onClickChild(value, color) {
            this.content = {
                content: value,
                color: color
            };
        }
    }
};
</script>


